import React from "react";
import { Form, Radio, Input, Space } from "antd";

interface Props {
  activeQuestion?: any;
  userValue?: any;
}

const SingleQuestionWithJumpQuestion: React.FC<Props> = (props) => {
  const checkJumpQuestionValue = (val: any) => {
    props?.userValue(val);
  };

  return (
    <div className="answer-input-wrapper">
      <Form.Item
        className="questionlist-radio"
        name={props?.activeQuestion?.data?.question}
        rules={[
          { required: true, message: "You have to select alteast one option" },
        ]}
      >
        <Radio.Group
          onChange={(e) => {
            checkJumpQuestionValue(e.target.value);
          }}
        >
          <Space direction="vertical">
            {props?.activeQuestion?.options.map((option: any, index: any) => {
              return (
                <Radio value={option} key={index} className="with-index">
                  <div className="index-no">{index + 1}.</div>
                  {option}
                </Radio>
              );
            })}
          </Space>
        </Radio.Group>
      </Form.Item>
    </div>
  );
};
export default SingleQuestionWithJumpQuestion;
